import React, { useState, useEffect } from 'react';
import { Button, Form, Col, Row } from 'react-bootstrap';

import ComisionDelServicioForm from './ComisionDelServicioForm';
import DetallesDelServicioForm from './DetallesDelServicioForm';
import ImpuestosTrasladadosForm from './ImpuestosTrasladadosForm';
import ContribucionGubernamentalForm from './ContribucionGubernamentalForm';

const DetallesDelServicioMain = (props) => {
  const [data, setData] = useState({});
  const [additionals, setAdditionals] = useState({});
  const [steps, setSteps] = useState({ isValidDetallesDelServicio: false });

  useEffect(() => {
    const { editing } = props;

    if (!!editing) {
      setData({ ...editing });

      const { ComisionDelServicio, ContribucionGubernamental, ImpuestosTrasladadosdelServicio } = editing;

      let newSteps = {};
      let newAdditionals = {};

      if (ComisionDelServicio) {
        newAdditionals.ComisionDelServicio = true;
        newSteps.isValidComisionDelServicio = true;
      }

      if (ContribucionGubernamental) {
        newAdditionals.ContribucionGubernamental = true;
        newSteps.isValidContribucionGubernamental = true;
      }

      if (ImpuestosTrasladadosdelServicio) {
        newAdditionals.ImpuestosTrasladadosdelServicio = true;
        newSteps.isValidImpuestosTrasladadosdelServicio = true;
      }

      setSteps({
        ...steps,
        isValidDetallesDelServicio: true,
        ...newSteps,
      });

      setAdditionals({
        ...additionals,
        ...newAdditionals,
      });
    }
  }, [!!props.editing]); // eslint-disable-line

  const handleOnChange = (event, validate) => {
    setData({
      ...data,
      ...event,
    });

    setSteps({
      ...steps,
      [validate.name]: validate.isValid,
    });
  };

  const handleOnAdd = () => {
    props.onAdd(data);

    setData({});
    setSteps({});
    setAdditionals({});
  };

  const handleOnAdditionalForm = (controlId, checked, label) => {
    return (
      <Row>
        <Col>
          <Form.Group controlId={controlId}>
            <Form.Check
              type="checkbox"
              name={controlId}
              label={label}
              checked={checked || false}
              onChange={handleOnAdditionalCheckboxChange}
            />
          </Form.Group>
        </Col>
      </Row>
    );
  };

  const handleOnAdditionalCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setAdditionals({
      ...additionals,
      [name]: checked,
    });

    if (checked) {
      setSteps({
        ...steps,
        ['isValid' + name]: !checked,
      });
    } else {
      delete steps['isValid' + name];

      setSteps({ ...steps });

      delete data[name];

      setData({ ...data });
    }
  };

  const isValidAllForms = () => {
    let isValid = false;

    for (const key in steps) {
      if (Object.prototype.hasOwnProperty.call(steps, key)) {
        if (steps[key] === false) {
          isValid = false;
          break;
        }

        isValid = steps[key] ?? false;
      }
    }

    return isValid;
  };

  const { version } = props;
  const { ComisionDelServicio, ContribucionGubernamental, ImpuestosTrasladadosdelServicio } = additionals;

  return (
    <>
      <DetallesDelServicioForm
        data={data ?? {}}
        version={version}
        onFormDataChange={handleOnChange}
      />

      {handleOnAdditionalForm(
        'ImpuestosTrasladadosdelServicio',
        ImpuestosTrasladadosdelServicio,
        'Incluir impuestos trasladados'
      )}

      {ImpuestosTrasladadosdelServicio && (
        <ImpuestosTrasladadosForm
          data={data?.ImpuestosTrasladadosdelServicio ?? {}}
          version={version}
          onFormDataChange={handleOnChange}
        />
      )}

      {handleOnAdditionalForm(
        'ContribucionGubernamental',
        ContribucionGubernamental,
        'Incluir contribución gubernamental'
      )}

      {ContribucionGubernamental && (
        <ContribucionGubernamentalForm
          data={data?.ContribucionGubernamental ?? {}}
          version={version}
          onFormDataChange={handleOnChange}
        />
      )}

      {handleOnAdditionalForm('ComisionDelServicio', ComisionDelServicio, 'Incluir comisión del servicio')}

      {ComisionDelServicio && (
        <ComisionDelServicioForm
          data={data?.ComisionDelServicio ?? {}}
          version={version}
          onFormDataChange={handleOnChange}
        />
      )}

      <Row>
        <Col>
          <p className="text-muted">
            Puedes agregar varios Servicios usando el botón "Agregar detalle del servicio", la lista se mostrará en la
            tabla.
          </p>
        </Col>
      </Row>

      <Row className="pt-3">
        <Col className="text-right">
          <Button
            variant="secondary"
            disabled={!isValidAllForms()}
            onClick={handleOnAdd}
          >
            Agregar detalles del servicio
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default DetallesDelServicioMain;
